import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Icon, Skeleton, EmptyState, fmtNum } from "../ui";
import { Cover, FLAG_LABEL } from "./Card";
import { personalize } from "../CharacterCard";
import content from "../../services/api-content";
import { useToast } from "../../context/ToastContext";
import "../../styles/content.css";

/** โหมดปัดตัวละคร: ปัดซ้าย/ปุ่ม ✕ = ข้าม, ปัดขวา/ปุ่ม ♥ = สนใจ (ไลก์) ; แตะการ์ดดูรายละเอียด */
export default function SwipeDeck({ userName }) {
  const [queue, setQueue] = useState(null);
  const [page, setPage] = useState(1);
  const [dir, setDir] = useState("");
  const [error, setError] = useState("");
  const [seen, setSeen] = useState(0);
  const touch = useRef(null);
  const toast = useToast();
  const navigate = useNavigate();

  const load = useCallback(async (p) => {
    try {
      const r = await content.characters.list({ sort: "trending", page: p, limit: 12 });
      setQueue((q) => [...(q || []), ...r.items]);
      setPage(p);
      if (!r.hasMore) setPage(0);
    } catch (e) {
      setError(e.message);
    }
  }, []);
  useEffect(() => { load(1); }, [load]);
  useEffect(() => { if (queue && queue.length < 3 && page > 0) load(page + 1); }, [queue, page, load]);

  const cur = queue?.[0];
  const act = async (like) => {
    if (!cur || dir) return;
    setDir(like ? "right" : "left");
    if (like) content.characters.like(cur.id).then(() => toast(`ถูกใจ ${cur.name} แล้ว`, "success")).catch((e) => toast(e.message, "error"));
    setTimeout(() => { setQueue((q) => q.slice(1)); setDir(""); setSeen((n) => n + 1); }, 220);
  };
  const onKey = (e) => { if (e.key === "ArrowLeft") act(false); if (e.key === "ArrowRight") act(true); };

  if (error) return <EmptyState icon="⚠️" title="โหลดตัวละครไม่สำเร็จ"><span className="error-text">{error}</span></EmptyState>;
  if (!queue) return <Skeleton height={460} radius={24} style={{ maxWidth: 380, margin: "0 auto" }} />;
  if (!cur) return <EmptyState icon="🎉" title="ดูครบแล้ว!" action={<Button onClick={() => navigate("/")}>กลับหน้าแรก</Button>}>วันนี้ปัดไปแล้ว {seen} ตัว ไว้มาใหม่พรุ่งนี้</EmptyState>;

  return (
    <div className="swipe-stage" tabIndex={0} onKeyDown={onKey} aria-label="ปัดตัวละคร ใช้ลูกศรซ้ายขวาหรือปุ่มด้านล่าง"
      onTouchStart={(e) => { touch.current = e.touches[0].clientX; }}
      onTouchEnd={(e) => { const dx = e.changedTouches[0].clientX - (touch.current ?? 0); if (Math.abs(dx) > 60) act(dx > 0); touch.current = null; }}>
      <div className={`swipe-card${dir ? ` is-${dir}` : ""}`}>
        <Cover c={cur} size="med" className="swipe-card__img" style={{}}>
          <div className="swipe-card__info">
            <div className="row-between"><h2 style={{ color: "#fff" }}>{cur.name}</h2><span className="badge"><Icon name="chat" size={11} /> {fmtNum(cur.messageCount)}</span></div>
            <p className="clamp-2" style={{ color: "#fff", opacity: 0.9, margin: "6px 0 10px" }}>{personalize(cur.tagline, userName)}</p>
            <div className="chip-row" style={{ flexWrap: "wrap" }}>
              {FLAG_LABEL[cur.flag] ? <span className="badge">{FLAG_LABEL[cur.flag]}</span> : null}
              {(cur.tags || []).slice(0, 4).map((t) => <span key={t} className="badge">{t}</span>)}
            </div>
          </div>
        </Cover>
      </div>
      <div className="swipe-actions">
        <Button variant="ghost" aria-label="ข้าม" onClick={() => act(false)} style={{ borderRadius: "50%" }}><Icon name="x" size={26} /></Button>
        <Link to={`/c/${cur.id}`} className="btn" style={{ borderRadius: "50%", width: 60, height: 60 }} aria-label="ดูรายละเอียด"><Icon name="book" size={24} /></Link>
        <Button variant="primary" aria-label="สนใจ" onClick={() => act(true)} style={{ borderRadius: "50%" }}><Icon name="heart" size={26} filled /></Button>
      </div>
      <p className="faint center mt-16" style={{ fontSize: 12 }}>ปัดขวา = ถูกใจ · ปัดซ้าย = ข้าม</p>
    </div>
  );
}
